import {
  type CreatePaymentV1Dto,
  type PatchPaymentV1Dto,
  PaymentsService,
  type PaymentV1Dto,
} from '@/openapi';
import { eventBus } from '@/configs/eventBus';

import type { PaymentSimple } from '../paymentTypes';

export function usePayments() {
  const fetchPayment = async (id: string) => {
    try {
      return await PaymentsService.paymentControllerV1FindOneV1(id);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchPayments = async () => {
    try {
      return await PaymentsService.paymentControllerV1FindAllV1();
    } catch (err) {
      console.log(err);
    }
  };

  const createPayment = async (data: CreatePaymentV1Dto) => {
    try {
      await PaymentsService.paymentControllerV1CreateV1(data);
      eventBus.emit('create');
    } catch (err) {
      console.log(err);
    }
  };

  const updatePayment = async (id: string, data: PatchPaymentV1Dto) => {
    try {
      await PaymentsService.paymentControllerV1UpdatePartialV1(id, data);
      eventBus.emit('update');
    } catch (err) {
      console.log(err);
    }
  };

  const deletePayment = async (id: string) => {
    try {
      await PaymentsService.paymentControllerV1RemoveOneV1(id);
      eventBus.emit('delete');
    } catch (err) {
      console.log(err);
    }
  };

  const deletePayments = async (ids: string[]) => {
    try {
      await PaymentsService.paymentControllerV1RemoveManyV1({ values: ids });
      eventBus.emit('delete');
    } catch (err) {
      console.log(err);
    }
  };

  return {
    fetchPayment,
    fetchPayments,
    createPayment,
    updatePayment,
    deletePayment,
    deletePayments,
  };
}

export function usePaymentsConverter() {
  const convertPaymentDtoToPaymentSimple = (item: PaymentV1Dto): PaymentSimple => {
    const {
      createdAt: _createdAt,
      modifiedAt: _modifiedAt,
      customer,
      customerBankingAccount,
      partner,
      partnerBankingAccount,
      ...res
    } = item;
    return {
      ...res,
      customerId: customer.id,
      customerName: customer.name,
      partnerId: partner.id,
      partnerName: partner.name,
      customerBankingAccountId: customerBankingAccount.id,
      partnerBankingAccountId: partnerBankingAccount.id,
    };
  };

  const convertPaymentDtoListToPaymentSimpleList = (data: PaymentV1Dto[]): PaymentSimple[] => {
    return data.map((item) => {
      return convertPaymentDtoToPaymentSimple(item);
    });
  };

  const convertPaymentSimpleToCreatePaymentDto = (data: PaymentSimple): CreatePaymentV1Dto => {
    const {
      id: _id,
      version: _version,
      customerName: _customerName,
      partnerName: _partnerName,
      ...res
    } = data;
    return {
      ...res,
    };
  };

  const convertPaymentSimpleToUpdatePaymentDto = (data: PaymentSimple): PatchPaymentV1Dto => {
    const { id: _id, customerName: _customerName, partnerName: _partnerName, ...res } = data;
    return {
      ...res,
    };
  };

  return {
    convertPaymentDtoToPaymentSimple,
    convertPaymentDtoListToPaymentSimpleList,
    convertPaymentSimpleToCreatePaymentDto,
    convertPaymentSimpleToUpdatePaymentDto,
  };
}
